import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function articlesCategoryReducer(state = initialState.articleCategory, action) {
    switch (action.type) {
        case types.GET_ARTICLE_CATEGORY_SUCCESS:
            return action.category;
        case types.RESET_ARTICLE_CATEGORY:
            return {name: '', description: '', portalId: null};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/articleCategoryReducer.js